module.exports = __webpack_public_path__ + "img/Nymbleup Order Type.5ce9eb0e.png";